<ng-container *transloco="let t; prefix: scope">
  <p-dialog
    [(visible)]="visible"
    showEffect="fade"
    [modal]="true"
    [style]="{ width: '540px', 'min-height': '420px' }"
    [contentStyle]="{ overflow: 'visible' }"
    [closable]="!sending"
    [closeOnEscape]="!sending"
    [dismissableMask]="!sending"
    (onHide)="onHidden()"
    [draggable]="false">
    <ng-template pTemplate="header">
      <span class="font-bold text-lg block truncate max-w-[440px]" [title]="fileName">
        {{ t('shareTitle', { fileName: fileName }) }}
      </span>
    </ng-template>

    <div class="flex items-center gap-2 w-full">
      <p-dropdown
        class="min-w-0 flex-1"
        styleClass="w-full"
        appendTo="body"
        [options]="invitableUsers"
        optionLabel="name"
        optionValue="id"
        [filter]="true"
        filterBy="name,email"
        [showClear]="true"
        [autoDisplayFirst]="false"
        [disabled]="loadingUsers || sending"
        [placeholder]="loadingUsers ? t('loadingUsers') : t('searchPlaceholder')"
        [(ngModel)]="selectedUserId">
        <ng-template pTemplate="selectedItem" let-user>
          <div class="truncate" [title]="userLabel(user)">{{ userLabel(user) }}</div>
        </ng-template>
        <ng-template pTemplate="item" let-user>
          <div class="max-w-[300px] truncate" [title]="userLabel(user)">{{ userLabel(user) }}</div>
        </ng-template>
      </p-dropdown>
      <bl-frontend-button class="shrink-0" variant="secondary" [text]="t('add')" [disabled]="!canAdd" (onclick)="add()">
      </bl-frontend-button>
      <bl-frontend-button class="shrink-0" variant="secondary" [text]="t('addAll')" [disabled]="!canAddAll" (onclick)="addAll()">
      </bl-frontend-button>
    </div>

    <div class="mt-5">
      <label class="font-bold block">{{ t('whoHasAccess') }}</label>

      <div *ngIf="access.length === 0" class="mt-2 italic text-description">{{ t('noRecipients') }}</div>

      <div class="max-h-[250px] overflow-y-auto -mx-1 px-1 -my-1 py-1">
        <div *ngFor="let granted of access" class="mt-3 flex items-center justify-between gap-2">
          <span class="min-w-0 truncate" [title]="userName(granted.cloudUserId)">{{ userName(granted.cloudUserId) }}</span>
          <div class="flex items-center gap-2">
            <p-dropdown
              class="shrink-0"
              styleClass="min-w-36"
              appendTo="body"
              [options]="roleOptions"
              optionLabel="label"
              optionValue="value"
              [ngModel]="granted.role"
              [disabled]="sending"
              (ngModelChange)="changeRole(granted, $event)">
            </p-dropdown>
            <bl-frontend-button
              class="shrink-0"
              variant="tonal"
              density="slim"
              [title]="t('removeAccess')"
              [disabled]="sending"
              [leadingIcon]="{ name: 'trash-alt' }"
              (onclick)="remove(granted)"></bl-frontend-button>
          </div>
        </div>
      </div>
    </div>

    <ng-template pTemplate="footer">
      <div class="flex justify-between gap-2">
        <div>
          <bl-frontend-button
            *ngIf="file"
            variant="secondary"
            [text]="t('uploadWithoutSharing')"
            [disabled]="!canUploadWithoutRecipients"
            (onclick)="uploadWithoutRecipients()">
          </bl-frontend-button>
        </div>
        <bl-frontend-button variant="primary" [text]="t('share')" [disabled]="!canShare" (onclick)="share()">
        </bl-frontend-button>
      </div>
    </ng-template>
  </p-dialog>
</ng-container>
